import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  private _loader;

  public set loader(value: boolean | string) {
    if (value) {
      this._loader = this.loadingController.create({
        message: typeof value === 'string' ? value : '',
        spinner: 'crescent',
        backdropDismiss: false,
        showBackdrop: true,
        cssClass: 'api-loader',
        mode: 'ios',
        translucent: true,
      }).then(loader => loader.present());
    } else {
      this._loader.then(loader => loader?.dismiss());
    }
  }

  constructor(
    private loadingController: LoadingController
  ) {}

  public get isLoading(): boolean {
    return this.loading > 0;
  }
  private _loading: number = 0;

  private get loading() {
    return this._loading;
  }

  private set loading(value) {
    this._loading = Math.max(value, 0);
  }

  public startLoading() {
    this.loading++;
  }
  public stopLoading() {
    this.loading--;
  }
}
